var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 37",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 286"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC81C\\uC678 1",
    d: "M4.485 15.97H.858a.831.831 0 0 1-.858-.8V.8A.831.831 0 0 1 .858 0h9.73a.833.833 0 0 1 .862.8v14.37a.833.833 0 0 1-.862.8H6.966v-3.243H4.485v3.242zm2.063-6.986V11.1h2.116V8.984zm-3.757 0V11.1h2.115V8.984zm3.757-3.5V7.6h2.116V5.485zm-3.757 0V7.6h2.115V5.485zm3.757-3.5V4.1h2.116V1.985zm-3.757 0V4.1h2.115V1.985z",
    transform: "translate(4.276 2.016)",
    style: {
      fill: "#current",
      stroke: "transparent",
      strokeMiterlimit: 10
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSite);
export default __webpack_public_path__ + "static/media/icon_site.53c777f213eb619529dcc2fc10599dca.svg";
export { ForwardRef as ReactComponent };